function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 11.2a.8.8 0 110 1.6.8.8 0 010-1.6zm3.2 0a.8.8 0 110 1.6.8.8 0 010-1.6zm-6.4 0a.8.8 0 110 1.6.8.8 0 010-1.6zm9.519 1.835c-.406 2.603-2.504 4.763-5.103 5.25a6.402 6.402 0 01-3.694-.39 2.572 2.572 0 00-1.002-.21c-.152 0-.303.015-.45.045l-2.25.45.45-2.254a2.465 2.465 0 00-.166-1.448 6.408 6.408 0 01-.39-3.694c.488-2.6 2.646-4.697 5.25-5.103 2.072-.322 4.099.33 5.561 1.793 1.463 1.463 2.117 3.49 1.794 5.561zm-.662-6.692C15.83 4.515 13.301 3.7 10.718 4.099c-3.262.51-5.966 3.136-6.576 6.39a8.006 8.006 0 00.489 4.612.88.88 0 01.071.511l-.686 3.43A.797.797 0 004.8 20a.807.807 0 00.157-.015l3.427-.686a.92.92 0 01.514.07 8.015 8.015 0 004.612.49c3.254-.61 5.882-3.315 6.39-6.576.402-2.582-.415-5.112-2.243-6.94z"
});

function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgContact;